// Programming Overview colour helpers (spec 41). Category colours are
// arbitrary hex chosen by an admin, so we can't assume white text always
// reads — pick black/white per-fill by relative luminance (WCAG-ish).

// Parse '#RGB' / '#RRGGBB' / '#RRGGBBAA' → [r,g,b] 0-255, or null.
function parseHex(hex: string): [number, number, number] | null {
  const h = hex.trim().replace(/^#/, '')
  if (h.length === 3) {
    const r = parseInt(h[0]! + h[0]!, 16)
    const g = parseInt(h[1]! + h[1]!, 16)
    const b = parseInt(h[2]! + h[2]!, 16)
    return [r, g, b]
  }
  if (h.length === 6 || h.length === 8) {
    const r = parseInt(h.slice(0, 2), 16)
    const g = parseInt(h.slice(2, 4), 16)
    const b = parseInt(h.slice(4, 6), 16)
    return [r, g, b]
  }
  return null
}

// Readable text colour for a given background fill. Returns near-black or white.
export function readableTextOn(hex: string): string {
  const rgb = parseHex(hex)
  if (!rgb) return '#1a1a1a'
  const [r, g, b] = rgb
  // Relative luminance (sRGB, simple gamma-less approximation is fine here).
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return lum > 0.6 ? '#1a1a1a' : '#ffffff'
}

// A faint tinted background from a hex fill (for legend chips / hovers).
export function tintFrom(hex: string, alpha = 0.14): string {
  const rgb = parseHex(hex)
  if (!rgb) return 'transparent'
  const [r, g, b] = rgb
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
